import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  singleTitleMapping,
  resolveBreadcrumbTitles,
} from "./Components/TitleMappings";
import PageHeaderAction from "./Components/PageHeaderAction";

const CommonBreadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const endDate = new Date("2025-12-31T23:59:59");

  const calcTime = () => {
    const diff = endDate - new Date();
    if (diff <= 0) return null;

    return {
      d: Math.floor(diff / (1000 * 60 * 60 * 24)),
      h: Math.floor((diff / (1000 * 60 * 60)) % 24),
      m: Math.floor((diff / (1000 * 60)) % 60),
      s: Math.floor((diff / 1000) % 60),
    };
  };

  const [time, setTime] = useState(calcTime());

  // Live timer (never stops)
  useEffect(() => {
    const t = setInterval(() => setTime(calcTime()), 1000);
    return () => clearInterval(t);
  }, []);

  // ✅ Get breadcrumb title list dynamically
  const breadcrumbParts = resolveBreadcrumbTitles(pathname, singleTitleMapping);

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-2 page-header">
      <ol className="breadcrumb mb-0 bg-transparent">
        <li className="breadcrumb-item">
          <Link to={pathname === "/index-hr" ? "/index-hr" : "/"}>Home</Link>
        </li>

        {breadcrumbParts.map((part, index) => (
          <li
            key={part.path}
            className={`breadcrumb-item ${
              index === breadcrumbParts.length - 1 ? "active" : ""
            }`}
          >
            {index === breadcrumbParts.length - 1 ? (
              <span>{part.title}</span>
            ) : (
              <Link to={part.path}>{part.title}</Link>
            )}
          </li>
        ))}
      </ol>

      <ul className="list-unstyled action d-flex align-items-center mb-0">
        {/* <PageHeaderAction /> */}
        {/* <div
          style={{
            backgroundColor: "#f8d7da",
            border: "1px solid #f5c2c7",
            color: "#842029",
            borderRadius: "10px",
            padding: "10px 16px",
            fontSize: "18px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: "10px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              backgroundColor: "#dc3545",
              borderRadius: "50%",
            }}
          />
          Subscription Ends in {time.d}d {time.h}h {time.m}m {time.s}s
        </div> */}
      </ul>
    </div>
  );
};

export default CommonBreadcrumb;
